module.exports = __webpack_public_path__ + "assets/img/f0d4a2753f98a59430fca941aed09e77.svg";